import Api from 'libs/api';
import AuthService from 'services/Auth';

class SettingsApi extends Api {
  constructor(restaurantId) {
    const resId = restaurantId || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/settings`);
  }

  updateDelivery = (data) => {
    this.buildQuery('post', { data }, 'delivery_zips');
  };

  updateIpratico = data => {
    return this.buildQuery('put', { data }, 'settings');
  }

  deleteDelivery = (id) => {
    this.buildQuery('delete', {}, `delivery_zips/${id}`);
  };

  updateOpeningHours = (service, data) => {
    return this.put(`opening_hours/${service}`, { data });
  };
}

export default SettingsApi;
